import { render, staticRenderFns } from "./OrderFile.vue?vue&type=template&id=7a8555f7&scoped=true&"
import script from "./OrderFile.vue?vue&type=script&lang=js&"
export * from "./OrderFile.vue?vue&type=script&lang=js&"
import style0 from "./OrderFile.vue?vue&type=style&index=0&id=7a8555f7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8555f7",
  null
  
)

export default component.exports